module.exports = __webpack_public_path__ + "static/media/video.783df079.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/VanMasters/video.jpg
// module id = 255
// module chunks = 0